import React from 'react'

const VideoSection = () => {
  return (
    <div class="banner__video--section">
    <div class="container-fluid">
      <div class="banner__video--thumbnail position__relative">
        <img
          class="banner__video--thumbnail__img display-block"
          src="assets/img/banner/banner-bg1.webp"
          alt="banner-bideo-thumbnail"
        />
        
      </div>
    </div>
  </div>
  )
}

export default VideoSection